/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { SearchCellsRequestPageInfoFromJSON, SearchCellsRequestPageInfoToJSON, } from './';
export function SearchCellsRequestFromJSON(json) {
    return SearchCellsRequestFromJSONTyped(json, false);
}
export function SearchCellsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        pageInfo: !exists(json, 'pageInfo') ? undefined : SearchCellsRequestPageInfoFromJSON(json['pageInfo']),
        tagIdsFilters: json['tagIdsFilters'],
    };
}
export function SearchCellsRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        pageInfo: SearchCellsRequestPageInfoToJSON(value.pageInfo),
        tagIdsFilters: value.tagIdsFilters,
    };
}
